// src/data/heroSources.js
// Build hero image list from your shorthand. Uses your /public/images/products/... structure.
// Filenames are IMG_<num>.JPEG (uppercase) as per your screenshot.

const BASE = "/images/products";

const SHORTHAND = [
  { folder: "genoBasil",    nums: [4462, 4479, 4496, 4565] },
  { folder: "chives",       nums: [4857] },
  { folder: "cress",        nums: [4581] },
  { folder: "komatsuna",    nums: [4483] },
  { folder: "seedlings",    nums: [4846] },
  { folder: "sorrel",       nums: [5042] },
  { folder: "redAmaranth",  nums: [7317, 7327] },
  { folder: "mizuna",       nums: [7331, 7332] },
  { folder: "parsley",      nums: [7347, 7349] },
];

// Optional per-folder default focal point (CSS object-position)
const FOCAL = {
  basil: "50% 45%",
  chives: "50% 50%",
  cress: "50% 50%",
  komatsuna: "50% 50%",
  lettuce: "50% 40%",
  seedlings: "50% 50%",
  sorrel: "50% 50%",
  redAmaranth: "50% 60%",
  mizuna: "50% 50%",
  parsley: "50% 50%",
};

function humanize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const HERO_SOURCES = SHORTHAND.flatMap(({ folder, nums }) =>
  nums.map((n) => {
    const src = `${BASE}/${folder}/IMG_${String(n)}.JPEG`;
    return {
      src,
      alt: `${humanize(folder)} - IMG_${n}`,
      focal: FOCAL[folder] || "50% 50%",
      weight: 1,
    };
  })
);
